import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// English files
import en_bbssafety from './locales/en/bbssafety.json';
import en_safetyhealth from './locales/en/safetyhealth.json';
import en_weeklydriver from './locales/en/weeklydriver.json';
import en_AIF from './locales/en/accidentinvestigation.json'
// Spanish files
import es_bbssafety from './locales/es/bbssafety.json';
import es_safetyhealth from './locales/es/safetyhealth.json';
import es_weeklydriver from './locales/es/weeklydriver.json';
import es_AIF from './locales/es/accidentinvestigation.json'

i18n
  .use(initReactI18next)
  .init({
    lng: 'en',
    fallbackLng: 'en',
    ns: ['bbssafety', 'safetyhealth', 'weeklydriver','AIF'],
    defaultNS: 'bbssafety',
    resources: {
      en: {
        bbssafety: en_bbssafety,
        safetyhealth: en_safetyhealth,
        weeklydriver: en_weeklydriver,
        AIF:en_AIF
      },
      es: {
        bbssafety: es_bbssafety,
        safetyhealth: es_safetyhealth,
        weeklydriver: es_weeklydriver,
        AIF:es_AIF
      },
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    }
  });

export default i18n;
